<template>
  <el-select v-model="currentCountry" placeholder="Select Country" filterable>
    <el-option
      v-for="item in countries"
      :key="item.code"
      :label="item.name"
      :value="item.code">
      <span class="flag">{{ item.flag }}</span>
      <span class="title">{{ item.name }}</span>
      <span class="code">{{ item.dial_code }}</span>
    </el-option>
  </el-select>
</template>

<script>
import countryCodesMixin from './countryCodesMixin';
import countryCodes from './countryCodes.json';

export default {
  name: 'CountryCodeSelector',

  mixins: [countryCodesMixin],

  data: () => ({
    countries: countryCodes,
  }),

  props: {
    browserCountryCode: {
      type: String,
      default: null,
    },
    selectedCountry: {
      type: String,
      default: null,
    },
  },

  computed: {
    currentCountry: {
      get() {
        return this.selectedCountry;
      },
      set(countryCode) {
        this.$emit('onCountryChanged', this.getCountryByCode(countryCode));
      },
    },
  },

  mounted() {
    if (this.browserCountryCode) {
      this.$emit('onCountryChanged', this.getCountryByCode(this.browserCountryCode));
    }
  },
};
</script>

<style lang="scss" scoped>
.flag {
  display: inline-block;
  width: 30px;
}
.title {
  padding-right: 12px;
}
.code {
  float: right;
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// CountryCodeSelector.vue?146a380a